import Component from '@glimmer/component'
import { service } from '@ember/service'
import { get } from '@ember/helper'
import { or } from 'ember-truth-helpers'
import { t } from 'ember-intl'
import { Precinct } from 'teacher-ui-client/utils/precincts'
import type GradeSetsService from 'teacher-ui-client/services/grade-sets'

const { RE_READING, RE_SPELLING, RE_STORYLANDS, REX_READING, REX_SPELLING } = Precinct
const rangeKeys = [RE_READING, RE_SPELLING, RE_STORYLANDS, REX_READING, REX_SPELLING] as const

type LessonGuideRow = Partial<Record<'gradeName' | (typeof rangeKeys)[number], string>>

interface Signature {
  Element: HTMLTableElement
}

export class LessonGuideTableReading extends Component<Signature> {
  @service gradeSets!: GradeSetsService

  rangeKeys = rangeKeys

  get rows(): LessonGuideRow[] {
    return [
      {
        gradeName: this.gradeSets.fullNameFromGradeSetByPosition(1),
        [RE_READING]: '1–50',
        [RE_SPELLING]: '1–32',
      },
      {
        gradeName: this.gradeSets.fullNameFromGradeSetByPosition(2),
        [RE_READING]: '51–100',
        [RE_SPELLING]: '33–64',
        [RE_STORYLANDS]: '1–10',
        [REX_READING]: '1–20',
        [REX_SPELLING]: '1–36',
      },
      {
        gradeName: this.gradeSets.fullNameFromGradeSetByPosition(3),
        [RE_READING]: '101–130',
        [RE_SPELLING]: '65–96',
        [RE_STORYLANDS]: '11–20',
        [REX_READING]: '21–60',
        [REX_SPELLING]: '37–72',
      },
      {
        gradeName: this.gradeSets.fullNameFromGradeSetByPosition(4),
        [REX_READING]: '61–100',
        [REX_SPELLING]: '73–108',
      },
      {
        gradeName: this.gradeSets.fullNameFromGradeSetByPosition(5),
        [REX_READING]: '101–140',
        [REX_SPELLING]: '109–144',
      },
      {
        gradeName: this.gradeSets.fullNameFromGradeSetByPosition(6),
        [REX_READING]: '141–180',
        [REX_SPELLING]: '145–180',
      },
      {
        gradeName: this.gradeSets.fullNameFromGradeSetByPosition(7),
        [REX_READING]: '181–220',
        [REX_SPELLING]: '181–216',
      },
    ]
  }

  <template>
    <table class="table-fixed" ...attributes>
      <thead>
        <tr>
          <th></th>
          <th class="table-box table-box-header bg-juicy-orange-200 text-center" colspan="3">
            {{t "tables.lessonGuide.headers.re.title"}}
          </th>
          <th class="table-box table-box-header bg-juicy-orange-200 text-center" colspan="2">
            {{t "tables.lessonGuide.headers.rex.title"}}
          </th>
        </tr>
        <tr class="h-20">
          <th></th>
          <th class="table-box table-box-header bg-juicy-orange-100 w-1/6 text-center">
            {{t "tables.lessonGuide.headers.re.lessons"}}
          </th>
          <th class="table-box table-box-header bg-juicy-orange-100 w-1/6 text-center">
            {{t "tables.lessonGuide.headers.re.spelling"}}
          </th>
          <th class="table-box table-box-header bg-juicy-orange-100 w-1/6 text-center">
            {{t "tables.lessonGuide.headers.re.clinkerCastle"}}
          </th>
          <th class="table-box table-box-header bg-juicy-orange-100 w-1/6 text-center">
            {{t "tables.lessonGuide.headers.rex.lessons"}}
          </th>
          <th class="table-box table-box-header bg-juicy-orange-100 w-1/6 text-center">
            {{t "tables.lessonGuide.headers.rex.spelling"}}
          </th>
        </tr>
      </thead>
      <tbody>
        {{#each this.rows as |row|}}
          <tr>
            <th class="table-box table-box-cell bg-juicy-orange-100 p-2 font-bold">{{row.gradeName}}</th>
            {{#each this.rangeKeys as |rangeKey|}}
              <td class="table-box table-box-cell bg-juicy-orange-50 p-2 text-center">
                {{or (get row rangeKey) "-"}}
              </td>
            {{/each}}
          </tr>
        {{/each}}
      </tbody>
    </table>
  </template>
}

export default LessonGuideTableReading
